import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

class Footer extends Component {
  render() {
    const { t } = this.props;

    return (
      <footer className="o-footer" role="contentinfo">
        <h1 className="sr-only">{t('title')}</h1>
        <div className="o-footer-bottom">
          <div className="container">
            <ul className="nav">
              <li className="nav-item">
                <span className="nav-link">© Orange 2018</span>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  data-toggle="collapse"
                  href="#collapseContacts"
                  aria-expanded="false"
                  aria-controls="collapseContacts"
                >
                  {t('contacts')}
                </a>
              </li>
            </ul>
          </div>
          <div className="collapse" id="collapseContacts">
            <div className="card text-white bg-dark mb-3 card-body">
              <p>
                {t('contactsContent1')}

                <a
                  className="card-link text-white"
                  href={`mailto:${t('mail')}`}
                >
                  {t('mail')}
                </a>
              </p>
            </div>
            <div className="card text-white bg-dark mb-3 card-body">
              {t('contactsContent2')}
            </div>
            <div className="card text-white bg-dark mb-3 card-body">
              {t('contactsContent3')}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  t: PropTypes.func.isRequired,
};
export default translate('Footer')(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js